import axios from 'axios';
import { HttpError } from './http-error.ts';

export function normalizeError(error: unknown): Error {
  if (error && axios.isAxiosError(error)) {
    const data = error.response?.data as { error?: { message?: string }; message?: string; code?: unknown };
    const msg = data?.message ?? data?.error?.message;
    return new HttpError(msg ?? error.message, error.response?.status, typeof data?.code === 'string' ? data.code : undefined);
  }

  return error instanceof Error ? error : new Error(String(error));
}
